import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ArticleList from './components/ArticleList';
import HotRanking from './components/HotRanking';
import BrandSection from './components/BrandSection';
import CTASection from './components/CTASection';
import { heroHeadlines } from '@/mocks/articles';

export default function Home() {
  const { t } = useTranslation();

  const structuredData = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: t('common:site.name'),
      url: 'http://baoliao91.cn/',
      description: t('common:seo.description'),
      potentialAction: {
        '@type': 'SearchAction',
        target: 'http://baoliao91.cn/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: t('common:site.name'),
      url: 'http://baoliao91.cn/',
      description: t('common:seo.description'),
      logo: 'http://baoliao91.cn/logo.png',
      sameAs: ['http://baoliao91.cn/'],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: t('common:site.name') + ' - 首页',
      description: t('common:seo.description'),
      url: 'http://baoliao91.cn/',
      isPartOf: {
        '@type': 'WebSite',
        name: t('common:site.name'),
        url: 'http://baoliao91.cn/',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name: '头条爆料',
      itemListElement: heroHeadlines.map((article, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'Article',
          headline: article.title,
          description: article.excerpt,
          url: `http://baoliao91.cn/article/${article.slug}`,
          image: article.coverImage,
          datePublished: article.publishDate,
          author: {
            '@type': 'Person',
            name: article.author,
          },
        },
      })),
    },
  ];

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <ArticleList />
        <HotRanking />
        <BrandSection />
        <CTASection />
      </main>
      <Footer />

      {structuredData.map((data, idx) => (
        <script
          key={idx}
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(data),
          }}
        />
      ))}
    </>
  );
}